import Orders from "../../Components/Orders"

const TransactionUser = () => {
    return (
        <Orders />
    )
}

export default TransactionUser